<h1 style="
 font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto,
   Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
 font-weight: 500;
 color: #105481;
 margin-bottom: 0.5rem;
 font-size: 2.5rem;
 font-weight: 500;
 line-height: 1.2;
 " id="editInrefHeader">
  {{infRef.infRefName ? infRef.infRefName : 'Ny InfRef'}}
</h1>


<form (ngSubmit)="submitClicked()" [formGroup]="profileForm">
  <table style="width: 100%; height: 155px" class="add-def-tab" aria-describedby="table">
    <th></th>
    <tr>
      <td style="width: 16%">
        <label appendTo="body" class="text" for="stat" id="infReflabel">InfRef:<span class="mandatory">*</span></label>
      </td>

      <td>
        <div class="p-inputgroup">
          <input formControlName="firstName" id="infRefInput" required pInputText appendTo="body"
            [(ngModel)]="infRefLocal.infRefName" name="infRefName" [readonly] ="isDisabled">
        </div>
        <div *ngIf="profileForm.controls['firstName'].invalid && profileForm.controls['firstName'].touched">
          <div *ngIf="profileForm.controls['firstName'].errors" style="color:red; font-size: 12px;">
            Navn er påkrævet
          </div>
        </div>
      </td>

      <td style="width: 10%" *ngIf="!newInref">
        <label *ngIf="infRefLocal.changedDate != null" appendTo="body" class="text" for="stat"
          id="chnagedbylabel2">Ændret:</label>
        <label *ngIf="infRefLocal.changedDate == null" appendTo="body" class="text" for="stat"
          id="chnagedbylabel2">Oprettet:</label>
      </td>

      <td *ngIf="!newInref">
        <label *ngIf="infRefLocal.changedDate != null" appendTo="body" class="text" id="chnagedbylabel3">

          {{ infRefLocal.changedDate.toLocaleDateString() + ' af ' + infRefLocal.changedBy }}

        </label>
        <label *ngIf="infRefLocal.changedDate == null" appendTo="body" class="text" id="chnagedbylabel3">


          {{ infRefLocal.createdDate?.toLocaleDateString() + ' af ' + infRefLocal.createdBy }}
        </label>
      </td>
    </tr>

    <tr>
      <td style="width: 19%">
        <label appendTo="body" class="text" for="stat" id="typeInput">Type:<span class="mandatory">*</span></label>
      </td>
      <td>
          <div class="p-inputgroup">
          <p-dropdown formControlName="type" id="typeDropdown" placeholder="Vælg fra liste" [options]="types"
            [(ngModel)]="infRefLocal.serviceType" name="serviceType" [readonly] ="isDisabled">
          </p-dropdown>

          <app-popover-btn title="Type" id="typepopup"
            text="Vælg hvilken type service, InfRef skal tilknyttes."></app-popover-btn>
        </div>
        <div *ngIf="profileForm.controls['type'].invalid && profileForm.controls['type'].touched">
          <div *ngIf="profileForm.controls['type'].errors" style="color:red; font-size: 12px;">
            Type er påkrævet
          </div>
        </div>
      </td>
    </tr>

    <tr>
      <td style="width: 19%">
        <label appendTo="body" class="text" for="stat" id="ruteTypelabel">Rute Type:<span
            class="mandatory">*</span></label>
      </td>
      <td>
        <mat-radio-group formControlName="routeType" [ngModelOptions]="{standalone: true}" aria-label="Select an option"
          name="radioButtons1" [(ngModel)]="infRefLocal.routingType" [disabled] ="isDisabled">
          <mat-radio-button color="primary" id="explicitRadio" value="IMPLICIT"><span>Implicit</span></mat-radio-button>
          <mat-radio-button color="primary" id="implicitRadio"
            value="EXPLICIT"><span>Eksplicit</span></mat-radio-button>
        </mat-radio-group>
      </td>
    </tr>


    <tr>
      <td style="width: 19%">
        <label appendTo="body" class="text" for="stat" id="activationlabel">Automatisk aktivering:<span
            class="mandatory">*</span></label>
      </td>
      <td>
        <mat-radio-group formControlName="automaticActivation" [ngModelOptions]="{standalone: true}"
          aria-label="Select an option" name="radioButtons" [(ngModel)]="infRefLocal.automaticActivationFlag">
          <mat-radio-button color="primary" id="activationTrue" [value]="true"><span>Ja</span></mat-radio-button>
          <mat-radio-button color="primary" id="activationFalse" [value]="false"><span>Nej</span></mat-radio-button>
        </mat-radio-group>
      </td>
    </tr>

    <tr>
      <td style="width: 19%">
        <label appendTo="body" class="text" for="stat" id="commentlabel">Kommentar:</label>
      </td>

      <td>
        <div class="p-inputgroup inputTextArea">
          <textarea appendTo="body" pInputTextarea id="commentInput" [ngModelOptions]="{standalone: true}" style="
            box-sizing: border-box;
            height: 86.5px;
            border-radius: 4px;
            width: 368px;
            flex: none;
            resize: vertical;
          " name="comment" maxlength="255" [(ngModel)]="infRefLocal.comment"></textarea>
        </div>
      </td>
    </tr>
  </table>
</form>

<div>
  <span>
    <button pButton class="add-button" [disabled]="!isSupportAdmin && !isSuperAdmin" label="Gem" type="submit"
      (click)="submitClicked()" id="gemButton"></button>
  </span>

  <span>
    <button pButton label="Annuller" class="add-button secondary" (click)="cancelClick()" id="annullerbutton2"></button>

  </span>
</div>
